export var ListBlockOptions;
(function (ListBlockOptions) {
    ListBlockOptions["POINT"] = "POINT";
    ListBlockOptions["CHECK"] = "CHECK";
    ListBlockOptions["NUMBER"] = "NUMBER";
    ListBlockOptions["CHECK_CIRCLE"] = "CHECK_CIRCLE";
    ListBlockOptions["CHECK_CIRCLE_OUTLINED"] = "CHECK_CIRCLE_OUTLINED";
})(ListBlockOptions || (ListBlockOptions = {}));
